/* istanbul ignore file */
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import { PolicyInfoPage, PolicyDetailsPage, OfferingsPage, LocationsPage, SuccessPage, DeclarationPage, RiskAnalysisPage } from 'premier-capability-policyjob-react';
import CodegenWizard from './CodegenWizard';
import { CodegenContext } from './components/CodegenContext';
import QuotePage from './pages/Quote/QuotePage';
import LiabilityCoveragesPage from './pages/LiabilityCoverages/LiabilityCoveragesPage';
import PropertyPage from './pages/Property/PropertyPage';
import PropertyCoveragesPage from './pages/PropertyCoverages/PropertyCoveragesPage';
import BeaSpaAndWellPage from './pages/BeaSpaAndWell/BeaSpaAndWellPage';
import HeaAndWellPage from './pages/HeaAndWell/HeaAndWellPage';

setComponentMapOverrides(
    {
        // wizard pages
        PremierOfferingsPage : { component: 'PremierOfferingsPage'},
        PremierSWPolicyDetailsPage: { component: 'PremierSWPolicyDetailsPage' },
        PremierSWLocationsPage: { component: 'PremierSWLocationsPage' },
        PremierSWLiabilityCoveragesPage: { component: 'PremierSWLiabilityCoveragesPage' },
        PremierSWPropertyPage: { component: 'PremierSWPropertyPage' },
        PremierSWPropertyCoveragesPage: { component: 'PremierSWPropertyCoveragesPage' },
        PremierSWRiskAnalysisPage: { component: 'PremierSWRiskAnalysisPage' },
        PremierSWBeaSpaWelPage: { component: 'PremierSWBeaSpaWelPage' },
        PremierSWHeaAndWelPage: { component: 'PremierSWHeaAndWelPage' },
        PremierSWQuotePage: { component: 'PremierSWQuotePage' },
        PremierSWPolicyInfoPage: { component: 'PremierSWPolicyInfoPage' },
        PremierSWDeclarationPage: { component: 'PremierSWDeclarationPage' },
        PremierSWSuccessPage: { component: 'PremierSWSuccessPage' },
    },
    {
        // wizard pages
        PremierOfferingsPage: OfferingsPage,
        PremierSWPolicyDetailsPage: PolicyDetailsPage,
        PremierSWLocationsPage: LocationsPage,
        PremierSWLiabilityCoveragesPage: LiabilityCoveragesPage,
        PremierSWPropertyPage: PropertyPage,
        PremierSWPropertyCoveragesPage: PropertyCoveragesPage,
        PremierSWRiskAnalysisPage: RiskAnalysisPage,
        PremierSWBeaSpaWelPage: BeaSpaAndWellPage,
        PremierSWHeaAndWelPage: HeaAndWellPage,
        PremierSWQuotePage: QuotePage,
        PremierSWPolicyInfoPage: PolicyInfoPage,
        PremierSWDeclarationPage: DeclarationPage,
        PremierSWSuccessPage: SuccessPage,
    }
);
export { CodegenWizard, CodegenContext };
